import { Reaction, ReactionType } from "~/src/components/Reaction"
import { isNil, isntNil } from "~/src/lib/any"

export type ThankYouNoteConfirmationProps = {
  message?: string
  reaction?: ReactionType
}

const Message = (props: { message: string }) => (
  <div className="z-0 flex justify-center rounded-md bg-white p-6">&ldquo;{props.message}&rdquo;</div>
)

const WrappedReaction = (props: { reaction: ReactionType }) => (
  <div className="flex justify-center">
    <Reaction reaction={props.reaction} className="h-14 w-14" />
  </div>
)

const MessageAndReaction = (props: { message: string; reaction: ReactionType }) => {
  const { reaction, message } = props

  return (
    <div>
      <Reaction reaction={reaction} className="z-10 -mb-4 h-14 w-14 -rotate-16" />
      <Message message={message} />
    </div>
  )
}

export function ThankYouNoteConfirmation(props: ThankYouNoteConfirmationProps) {
  const { message, reaction } = props

  const bothMessageAndReaction = isntNil(message) && isntNil(reaction)
  const justMessage = isntNil(message) && isNil(reaction)
  const justReaction = isntNil(reaction) && isNil(message)

  return (
    <section className="flex h-full justify-center bg-gray-100 p-14">
      <div className={`flex max-w-lg flex-col gap-5 md:gap-10 ${justReaction ? "justify-center" : ""}`}>
        <h1 className="text-navy-800 text-center text-3xl font-medium sm:text-6xl">
          Thanks, we&apos;ll pass your note along!
        </h1>
        {bothMessageAndReaction && <MessageAndReaction message={message} reaction={reaction} />}
        {justMessage && <Message message={message} />}
        {justReaction && <WrappedReaction reaction={reaction} />}
      </div>
    </section>
  )
}
